<template>
  <b-card
    no-body
    class="client-table"
  >
    <b-skeleton-table
      v-if="loading"
      :rows="10"
      :columns="fields.length"
    />
    <b-table
      v-if="!loading"
      :items="items"
      :fields="fields"
      class="client-table__data"
      show-empty
      :empty-text="$tk('ClientPortal.Catalogs.NoLogs')"
      :current-page="currentPage"
      :per-page="0"
      :total-rows="totalRows"
      responsive
    >
      <template #empty="scope">
        <div class="text-center p-3 client-table__empty">
          <div class="empty__client-table">
            <GjIcon
              size="64px"
              name="Book"
            />
            <div class="mb-50">
              {{ scope.emptyText }}
            </div>
          </div>
        </div>
      </template>
    </b-table>
    <b-card-footer
      v-if="items.length > 0"
      class="client-table__footer d-flex"
    >
      <b-pagination
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        class="my-0 mr-1"
        hide-goto-end-buttons
        @input="value => changePage(value)"
      >
        <template #prev-text>
          <GjIcon
            class="mr-25"
            name="ArrowLeft"
          />
        </template>
        <template #next-text>
          <GjIcon
            class="ml-25"
            name="ArrowRight"
          />
        </template>
      </b-pagination>
      <span>
        {{ $tk('ClientPortal.Pagination.Viewing') }} {{ fromCount }} {{ $tk('ClientPortal.Pagination.To') }} {{ toCount }} {{ $tk('ClientPortal.Pagination.Of') }} {{ totalRows }} {{ $tk('ClientPortal.Pagination.Items') }}
      </span>
    </b-card-footer>
  </b-card>
</template>

<script>
import CatalogsService from '@/api/client/catalogs.service'
import notification from '@/mixins/toastification'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    catalogId: String,
  },
  data() {
    return {
      items: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      loading: false,
      correctPage: 0,
    }
  },
  computed: {
    fromCount() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    toCount() {
      const toCount = this.fromCount + this.perPage - 1
      return Math.min(toCount, this.totalRows)
    },
    fields() {
      return [
        {
          key: 'message',
          label: this.$tk('ClientPortal.Catalogs.Logs.Message'),
        },
        {
          key: 'totalCatalogItems',
          label: this.$tk('ClientPortal.Catalogs.Logs.TotalCatalogItems'),
        },
        {
          key: 'addedCatalogItems',
          label: this.$tk('ClientPortal.Catalogs.Logs.InsertedCatalogItems'),
        },
        {
          key: 'updatedCatalogItems',
          label: this.$tk('ClientPortal.Catalogs.Logs.UpdatedCatalogItems'),
        },
        {
          key: 'removedCatalogItems',
          label: this.$tk('ClientPortal.Catalogs.Logs.RemovedCatalogItems'),
        },
        {
          key: 'crawlStartDateTime',
          label: this.$tk('ClientPortal.Catalogs.Logs.CrawlStartDateTime'),
        },
      ]
    },
  },
  async mounted() {
    await this.getLogs()
  },
  methods: {
    async getLogs() {
      this.loading = true
      try {
        const response = await CatalogsService.getCatalogLogs(this.catalogId, this.currentPage - 1, this.perPage, this.$route.params.accountId)
        this.items = response.logs
        this.totalRows = response.totalRecords
      } catch (err) {
        this.error(err.message)
      } finally {
        this.loading = false
      }
    },
    async changePage(page) {
      this.currentPage = page
      const response = await CatalogsService.getCatalogLogs(this.catalogId, this.currentPage - 1, this.perPage, this.$route.params.accountId)
      this.items = response.logs
    },
  },
}
</script>
